/* =====================================================================================
   Countries for autocomplete. The schema speaks ISO 3166-1 alpha-3; people type names.
   Names come from the browser's own locale data (Intl.DisplayNames) so nothing here
   goes stale; this file only carries the alpha-2 -> alpha-3 bridge.
   ===================================================================================== */

const A2_A3 = ('AF:AFG AX:ALA AL:ALB DZ:DZA AS:ASM AD:AND AO:AGO AI:AIA AG:ATG AR:ARG AM:ARM AW:ABW '
  + 'AU:AUS AT:AUT AZ:AZE BS:BHS BH:BHR BD:BGD BB:BRB BY:BLR BE:BEL BZ:BLZ BJ:BEN BM:BMU BT:BTN '
  + 'BO:BOL BA:BIH BW:BWA BR:BRA BN:BRN BG:BGR BF:BFA BI:BDI CV:CPV KH:KHM CM:CMR CA:CAN KY:CYM '
  + 'CF:CAF TD:TCD CL:CHL CN:CHN CO:COL KM:COM CG:COG CD:COD CR:CRI CI:CIV HR:HRV CU:CUB CW:CUW '
  + 'CY:CYP CZ:CZE DK:DNK DJ:DJI DM:DMA DO:DOM EC:ECU EG:EGY SV:SLV GQ:GNQ ER:ERI EE:EST SZ:SWZ '
  + 'ET:ETH FJ:FJI FI:FIN FR:FRA GF:GUF PF:PYF GA:GAB GM:GMB GE:GEO DE:DEU GH:GHA GI:GIB GR:GRC '
  + 'GL:GRL GD:GRD GP:GLP GU:GUM GT:GTM GG:GGY GN:GIN GW:GNB GY:GUY HT:HTI HN:HND HK:HKG HU:HUN '
  + 'IS:ISL IN:IND ID:IDN IR:IRN IQ:IRQ IE:IRL IM:IMN IL:ISR IT:ITA JM:JAM JP:JPN JE:JEY JO:JOR '
  + 'KZ:KAZ KE:KEN KI:KIR KP:PRK KR:KOR KW:KWT KG:KGZ LA:LAO LV:LVA LB:LBN LS:LSO LR:LBR LY:LBY '
  + 'LI:LIE LT:LTU LU:LUX MO:MAC MG:MDG MW:MWI MY:MYS MV:MDV ML:MLI MT:MLT MH:MHL MQ:MTQ MR:MRT '
  + 'MU:MUS YT:MYT MX:MEX FM:FSM MD:MDA MC:MCO MN:MNG ME:MNE MS:MSR MA:MAR MZ:MOZ MM:MMR NA:NAM '
  + 'NR:NRU NP:NPL NL:NLD NC:NCL NZ:NZL NI:NIC NE:NER NG:NGA NU:NIU MK:MKD NO:NOR OM:OMN PK:PAK '
  + 'PW:PLW PS:PSE PA:PAN PG:PNG PY:PRY PE:PER PH:PHL PL:POL PT:PRT PR:PRI QA:QAT RE:REU RO:ROU '
  + 'RU:RUS RW:RWA KN:KNA LC:LCA VC:VCT WS:WSM SM:SMR ST:STP SA:SAU SN:SEN RS:SRB SC:SYC SL:SLE '
  + 'SG:SGP SX:SXM SK:SVK SI:SVN SB:SLB SO:SOM ZA:ZAF SS:SSD ES:ESP LK:LKA SD:SDN SR:SUR SE:SWE '
  + 'CH:CHE SY:SYR TW:TWN TJ:TJK TZ:TZA TH:THA TL:TLS TG:TGO TO:TON TT:TTO TN:TUN TR:TUR TM:TKM '
  + 'TC:TCA TV:TUV UG:UGA UA:UKR AE:ARE GB:GBR US:USA UY:URY UZ:UZB VU:VUT VA:VAT VE:VEN VN:VNM '
  + 'VG:VGB VI:VIR YE:YEM ZM:ZMB ZW:ZWE').split(' ').map((p) => p.split(':') as [string, string]);

export interface Country { iso3: string; name: string }

let cache: Country[] | null = null;
export function countries(): Country[] {
  if (cache) return cache;
  const dn = new Intl.DisplayNames(['en'], { type: 'region' });
  cache = A2_A3.map(([a2, a3]) => ({ iso3: a3, name: dn.of(a2) ?? a3 }))
    .sort((a, b) => a.name.localeCompare(b.name));
  return cache;
}
export function countryName(iso3: string | null | undefined): string {
  if (!iso3) return '';
  return countries().find((c) => c.iso3 === iso3)?.name ?? iso3;
}
export function iso3For(nameOrCode: string): string | null {
  const t = nameOrCode.trim();
  if (/^[A-Za-z]{3}$/.test(t) && countries().some((c) => c.iso3 === t.toUpperCase())) {
    return t.toUpperCase();
  }
  const hit = countries().find((c) => c.name.toLowerCase() === t.toLowerCase());
  return hit ? hit.iso3 : null;
}
